import { Location } from '@angular/common';
import { Component, Input, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MateriaComentario } from '../../../models/comentario';
import { MateriaComentarioService } from '../../../services/materia.comentario.service';
import { DialogService } from '../../../services/dialog.service';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-materia-comentario',
  templateUrl: './materia-comentario.component.html',
  styleUrl: './materia-comentario.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MateriaComentarioComponent {
  @Input() id: number;

  comentarios: MateriaComentario[];
  comentario: MateriaComentario;
  submitted: boolean;
  error: string;

  formMateriaComentario: UntypedFormGroup;

  constructor(
    private _location: Location,
    private modalService: NgbModal,
    private materiaComentarioService: MateriaComentarioService,
    private dialogService: DialogService,
    private toastService: ToastService
  ) { }

  ngOnInit() {
    this.getComentarios();
    this.createForm(new MateriaComentario());
  }

  open(content: any) {
    this.modalService.open(content, { size: 'lg' });
  }
  getComentarios() {
    this.materiaComentarioService.getByMateriaId(this.id).subscribe({
      next: (res) => {
        this.comentarios = res;
      },
    });
  }

  submitForm() {
    this.submitted = true;

    if (this.formMateriaComentario.invalid) {
      this.error = 'Informações inválidas';
      return;
    }

    this.comentario = this.formMateriaComentario.value;
    this.materiaComentarioService.post(this.comentario).subscribe({
      next: () => {
        this.toastService.show('Comentário adicionado!', { type: 'success' });
        this.modalService.dismissAll();
        this.getComentarios();
      },
      error: () => {
        this.toastService.show('Não foi possível adicionar o comentário!', { type: 'danger' });
        this.modalService.dismissAll();
      },
    });
  }

  backClicked() {
    this._location.back();
  }

  createForm(materiaComentarioForm: any) {
    this.formMateriaComentario = new UntypedFormGroup({
      id: new UntypedFormControl((materiaComentarioForm.id = 0)),
      idMateria: new UntypedFormControl(
        (materiaComentarioForm.idMateria = this.id)
      ),
      comentario: new UntypedFormControl(
        materiaComentarioForm.comentario,
        Validators.required
      ),
      nome: new UntypedFormControl(
        materiaComentarioForm.nome,
        Validators.required
      ),
      email: new UntypedFormControl(materiaComentarioForm.email, [
        Validators.required,
        Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
      ]),
      data: new UntypedFormControl((materiaComentarioForm.data = new Date())),
    });
  }

  get f() {
    return this.formMateriaComentario.controls;
  }
}
